import { createContext } from "react";
import type { DragAndDropContextType } from "./DragAndDropContext.type.ts";

export const DragAndDropContext = createContext<DragAndDropContextType | null>(
  null,
);
